import { Box } from '@terra/ui-styled-system';
import type { TerraIcon } from '@terra/ui-icons';

export function AssetRowIcon({ icon: Icon }: { icon: TerraIcon }) {
  return (
    <Box
      w={6}
      h={6}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      bg="bg.entity.assets"
      borderWidth={1}
      borderColor="border.entity.assets"
      borderRadius="sm"
      color="fg.entity.assets"
      flexShrink={0}
    >
      <Icon size={16} />
    </Box>
  );
}
